<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div class="w-full max-w-md bg-white dark:bg-slate-800 rounded-xl shadow p-6">
        <h1 class="text-2xl font-semibold mb-6 text-gray-900 dark:text-gray-100">Entrar</h1>
  
        <form @submit.prevent="login" class="space-y-4">
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">E-mail</label>
            <input v-model.trim="email" type="email" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Senha</label>
            <input v-model="password" type="password" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <fwb-button gradient="green-blue" outline class="w-full py-2" :disabled="loading">
            {{ loading ? 'Entrando…' : 'Entrar' }}
          </fwb-button>
        </form>
        <p class="mt-4 text-sm text-gray-700 dark:text-gray-200">
          Não tem conta?
          <router-link to="/register" class="text-emerald-500 hover:underline">Criar conta</router-link>
        </p>
        <p class="mt-4 text-sm text-gray-700 dark:text-gray-200">
          Esqueceu a senha?
          <router-link to="/senha" class="text-emerald-500 hover:underline">Mudar a senha</router-link>
        </p>
        <p v-if="error" class="mt-4 text-sm text-red-500">{{ error }}</p>
      </div>
    </div>
    
  </template>
  
  <script>
  import axios from 'axios';
  import { FwbButton } from 'flowbite-vue';
  
  export default {
    name: 'LoginMain',
    components: { FwbButton },
    data() {
      return { 
        email: '', 
        password: '', 
        loading: false, 
        error: '', 
        apiBase: this.getApiBase()
      };
    },
    methods: {
      getApiBase() {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
          return 'http://localhost:5000';
        }
        return '/api';
      },
      async login() {
        this.loading = true; this.error = '';
        try {
          const { data } = await axios.post(`${this.apiBase}/auth/login`, {
            email: this.email, password: this.password,
          });
          const token = data.access_token;
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(data.user));
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  
          const redirect = this.$route.query.redirect || '/';
          this.$router.replace(redirect);
        } catch (e) {
          this.error = 'Credenciais inválidas.';
          console.error(e);
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>

